module.exports = __webpack_public_path__ + "img/thumbnail_Bongo_j_normal.d96ac80b.png";